// extracted by mini-css-extract-plugin
export default {"ingredientContainer":"burger-item_ingredientContainer__I8qlj"};